import { IconCollection } from "components/Icon/IconCollection";
import { ResourceConfig } from "config/config";
import {
    deleteActionSignature,
    DeleteListAction,
    deletePermanentlyActionSignature,
    duplicateActionSignature,
    exportActionSignature,
    migrateDeprecationsActionSignature,
    MigrateDeprecationsListAction,
    moveToLocationActionSignature,
    PermanentlyDeleteListAction,
} from "containers/Resources/components/CommonActions/CommonActions";

import type { SchematizedValues } from "components/Form/components/SchemaForm/SchemaForm.types";
import { scriptField, valueAndSchemaInputField } from "config/resources/sharedFieldsTyped";
import {
    commentsTab,
    inputSchemaTab,
    inputSchemaTabKey,
    logsTab,
    metadataTab,
    referencesUsedByTab,
    valueAndSchemaInput,
    wrappersTab,
} from "containers/Resources/screens/ResourcesSingle/constants";
import { executionPriorityColumn } from "containers/Search/components/SearchTabs/columns";
import resource from "./resource";
import { getLatestExecutions } from "./sharedFields";

const resourceName = "wrapper";

const config: ResourceConfig = {
    label: "Wrapper",
    icon: IconCollection.codeBraces,
    resourceName,
    resourceClass: "resource",
    defaultActiveTab: inputSchemaTabKey,
    layout: [
        { partial: "pageHeaderForm" },
        { partial: "form" },
        {
            partial: "tabs",
            config: {
                tabs: [
                    inputSchemaTab.tab,
                    wrappersTab.tab,
                    logsTab.tab,
                    commentsTab.tab,
                    referencesUsedByTab.tab,
                    metadataTab.tab,
                ],
                content: [
                    inputSchemaTab.content,
                    wrappersTab.content,
                    logsTab.content,
                    commentsTab.content,
                    referencesUsedByTab.content,
                    metadataTab.content,
                ],
            },
        },
    ],
    actions: {
        shown: [migrateDeprecationsActionSignature],
        hidden: [
            duplicateActionSignature,
            exportActionSignature,
            moveToLocationActionSignature,
            deleteActionSignature,
            deletePermanentlyActionSignature,
        ],
    },
    listActions: {
        shown: [],
        hidden: [
            { key: "delete", action: DeleteListAction },
            { key: "deletePermanently", action: PermanentlyDeleteListAction },
            { key: "migrateDeprecations", action: MigrateDeprecationsListAction },
        ],
    },
    graphql: {
        resource: resourceName,
        resourceBody: `
            ${resource.graphql.resourceBody}
            script
            breakpoints
            input_schema
            priority
            has_deprecation
            has_syntax_error
            max_runtime_minutes
        `,
        resourceBodyListing: `
            ${resource.graphql.resourceBody}
            has_deprecation
            has_syntax_error
            priority
        `,
        updateVariables: `
            ${resource.graphql.updateVariables(resourceName)}
            $script: String,
            $breakpoints: [Int],
            $input_schema: SchemalessData,
            $priority: Int
            $max_runtime_minutes: Int
        `,
        updateQuery: `
            ${resource.graphql.updateQuery(resourceName)}
            script: $script,
            breakpoints: $breakpoints,
            input_schema: $input_schema,
            priority: $priority
            max_runtime_minutes: $max_runtime_minutes
        `,
        createVariables: `
            ${resource.graphql.createVariables(resourceName)}
            $script: String
            $input_schema: SchemalessData,
            $breakpoints: [Int],
        `,
        createQuery: `
            ${resource.graphql.createQuery(resourceName)}
            script: $script
            input_schema: $input_schema,
            breakpoints: $breakpoints,
        `,
    },
    additionalColumns: (setNewValue) => [executionPriorityColumn(setNewValue)],
    statsSidebar: [getLatestExecutions("wrapper")],
    form: [scriptField, valueAndSchemaInputField()],
    formDTO: {
        initialValueDTO: (data: any) => {
            const valueAndSchemaInputFieldValues: SchematizedValues = {
                values: data?.input_value,
                schema: data?.input_schema,
            };
            return { ...data, [valueAndSchemaInput]: valueAndSchemaInputFieldValues };
        },
    },
};
export default config;
